import equalHeights from '../util/equalHeights';
export default {
  init() {
    // JavaScript to be fired on all pages
    // new WOW().init();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    equalHeights('.ads-equal-height');
    equalHeights('.equal-heights');
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js